import { custom } from "./actionsUtilities";
import {
  EMPTY_STRING,
  orchestratorConstants,
  SPINNER_MESSAGES,
  storeConstants,
  systemConstants,
  toastType,
} from "../../constants";
import { systemService } from "../../services";
import { customToast } from "../../shared/utility";
import { storeActions } from "./store.action";

//-------activate spinner
const activateSpinner = (data) => {
  return (dispatch) => {
    dispatch(custom(data, systemConstants.SPINNER_ACTIVATE));
  };
};

//-------Deactivate Spinner
const deactivateSpinner = (data) => {
  return (dispatch) => {
    dispatch(custom(data, systemConstants.SPINNER_DEACTIVATE));
  };
};

const activateDraggableNotification = (data = { message: EMPTY_STRING }) => {
  return (dispatch) => {
    dispatch(custom(data, systemConstants.DRAGGABLE_NOTIFICATION_ACTIVATE));
  };
};

const deactivateDraggableNotification = (data = { message: EMPTY_STRING }) => {
  return (dispatch) => {
    dispatch(custom(data, systemConstants.DRAGGABLE_NOTIFICATION_DEACTIVATE));
  };
};

//-------Page Redireaction
const pageRedireaction = (path) => {
  return (dispatch) => {
    dispatch(custom(path, systemConstants.TOGGLE_REDIRECT_PAGE));
  };
};

const dfStartOrchestrator = (data) => {
  return (dispatch) => {
    systemService
      .dfStartOrchestrator(data)
      .then(
        (response) => {
          dispatch(
            storeActions.getUpdatedCurrentStoreDetails(data.storeId, false)
          );
        },
        (error) => {
          dispatch(
            storeActions.getUpdatedCurrentStoreDetails(data.storeId, false)
          );
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {});
  };
};

const dfCancelOrchestrator = (data) => {
  return (dispatch) => {
    dispatch(
      custom(
        storeConstants.CANCEL_ORCHESTRATOR,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    systemService
      .dfCancelOrchestrator(data)
      .then(
        (response) => {
          if (
            data.orchestrator === orchestratorConstants.UPDATE_INVENTORY_PRESETS
          ) {
            dispatch(
              storeActions.getStoreMiscData(
                data.storeId,
                storeConstants.BG_JOB_RESET_INVENTORY_WITH_SHOPIFY
              )
            );
            dispatch(
              storeActions.getUpdatedCurrentStoreDetails(data.storeId, false)
            );
            dispatch(
              systemActions.deactivateDraggableNotification({
                message: SPINNER_MESSAGES.SHOPIFY_RESET_IN_PROGRESS,
              })
            );
          }
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            storeConstants.CANCEL_ORCHESTRATOR,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const systemActions = {
  activateSpinner,
  deactivateSpinner,
  pageRedireaction,
  dfStartOrchestrator,
  activateDraggableNotification,
  deactivateDraggableNotification,
  dfCancelOrchestrator,
};
